import api from './api';

const authService = {
  // 代理登入
  login: async (username, password) => {
    try {
      const response = await api.post('/agent/auth/login', {
        username,
        password
      });
      
      if (response.success) {
        return {
          success: true,
          token: response.token,
          agent: response.agent,
          needChangePassword: response.needChangePassword
        };
      }
      
      return {
        success: false,
        error: response.error || '登入失敗'
      };
    } catch (error) {
      // 檢查是否是 401 錯誤
      if (error.response && error.response.status === 401) {
        return {
          success: false,
          error: error.response.data?.error || '帳號或密碼錯誤'
        };
      }
      
      // 其他錯誤
      return {
        success: false,
        error: error.response?.data?.error || error.message || '登入失敗'
      };
    }
  },

  // 取得個人資料
  getProfile: async () => {
    try {
      const response = await api.get('/agent/auth/profile');
      
      if (response.success) {
        return {
          success: true,
          agent: response.agent,
          statistics: response.statistics
        };
      }
      
      return {
        success: false,
        error: response.error || '取得資料失敗'
      };
    } catch (error) {
      console.error('取得個人資料錯誤:', error);
      return {
        success: false,
        error: error.response?.data?.error || error.message || '取得資料失敗'
      };
    }
  },

  // 修改密碼
  changePassword: async (oldPassword, newPassword) => {
    try {
      const response = await api.post('/agent/auth/change-password', {
        oldPassword,
        newPassword
      });
      
      if (response.success) {
        return {
          success: true,
          message: response.message
        };
      }
      
      return {
        success: false,
        error: response.error || '修改密碼失敗'
      };
    } catch (error) {
      console.error('修改密碼錯誤:', error);
      return {
        success: false,
        error: error.response?.data?.error || error.message || '修改密碼失敗'
      };
    }
  },

  // 登出
  logout: async () => {
    try {
      await api.post('/agent/auth/logout');
      return { success: true };
    } catch (error) {
      console.error('登出錯誤:', error);
      // 登出總是視為成功
      return { success: true };
    }
  },

  // 檢查 token 是否有效
  validateToken: async () => {
    try {
      const response = await authService.getProfile();
      return response.success;
    } catch (error) {
      return false;
    }
  }
};

export default authService;